import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { PriceService } from '@app/_services/masters/price.service';
import { first } from 'rxjs/operators';
import { price } from '@app/_models/price';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LogService } from '../../../_shared/log.service'
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';

@Component({
  selector: 'app-price-master-edit',
  templateUrl: './price-master-edit.component.html',
  styleUrls: ['./price-master-edit.component.css']
})
export class PriceMasterEditComponent implements OnInit {

  docId: number;
  editPriceForm: FormGroup;
  price: price[];
  submitted = false;
  serviceName: string;
  documentType: string;
  yearrangeStart: number;
  yearrangeEnd: number;
  amount: number;
  response: any;
  priceId: number;
  getresponse: any;
  selectedStartYear = 0;
  selectedEndYear = 0;
  yearrangeStartData = [];
  yearrangeEndData = [];
  securitycharge: number;
  gst: number;
  yearGreaterthan;
  yearSmallerthan;
  DocumentTypeDropDown: [];
  selecteddocumentType: string;
  doctypeId: number;
  requestTypeId: number;

  getQuantity() {
    for (let i = 0; i <= 100; i++) {
      this.yearrangeStartData.push({ id: i, year: i })
    }
    for (let i = 1; i <= 100; i++) {
      this.yearrangeEndData.push({ id: i, year: i })
    }
  }
  // yearrangeStartData = [{ id: 1, year: "1" },
  // { id: 2, year: "2" },
  // { id: 3, year: "3" }];
  // // yearrangeStartData = [];
  // yearrangeEndData = [{ id: 1, year: "1" },
  // { id: 2, year: "2" },
  // // { id: 3, year: "3" }];

  get f() { return this.editPriceForm.controls; }

  //only number will be add
  keyPress(event: any) {
    const pattern = new RegExp(/^\d*\.?\d{0,2}$/g);
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  RequestTypeDropDown = [];
  showModalBox: boolean = false;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  constructor(private eventService: LogService, private formBuilder: FormBuilder, private priceService: PriceService,
    private modalService: NgbModal, private verifyDocService: VerifyDocumentService, config: NgbModalConfig) {

  }

  @Input() childMessage: price[];

  ngOnInit(): void {
    this.getQuantity();
    console.log("childMessage" + this.childMessage);
    this.response = this.childMessage;

    this.serviceName = this.response.requestType;
    this.priceId = this.response.id;
    this.amount = this.response.amount;
    var startYr: number = +this.response.yearrangeStart;
    this.selectedStartYear = startYr;
    var endYr: number = +this.response.yearrangeEnd;
    this.selectedEndYear = endYr;
    this.securitycharge = this.response.secure_charge;
    this.gst = this.response.gst;
    this.documentType = this.response.docType;
    this.requestTypeId = this.response.requestTypeid;
    this.doctypeId = this.response.docTypeid;

    this.editPriceForm = this.formBuilder.group({
      serviceName: ['', Validators.required],
      amount: ['', Validators.required],
      yearrangeStart: [0],
      yearrangeEnd: [0],
      securitycharge: ['', Validators.required],
      gst: ['', Validators.required],
      documentType: ['', Validators.required]
    });

    this.verifyDocService.getDocuments()
      .pipe(first())
      .subscribe(
        data => {
          this.DocumentTypeDropDown = data.respData;
        },
        error => {

          console.log(error)


        }
      )
    this.verifyDocService.getRequestType()
      .pipe(first())
      .subscribe(
        data => {
          this.RequestTypeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )



  }


  updatePrice() {
    this.submitted = true;

    if (this.editPriceForm.invalid) {
      return;
    }
    var v = new price();
    v.serviceName = this.serviceName;
    v.id = this.priceId;
    v.amount = this.amount;
    v.yearrangeStart = this.selectedStartYear;
    v.yearrangeEnd = this.selectedEndYear;
    v.securitycharge = this.securitycharge;
    v.gst = this.gst;
    v.doctypeId = this.doctypeId;
    v.requestTypeId = this.requestTypeId;
    this.priceService.updatePrice(v)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          if (this.getresponse.respMessage == "Success") {
            this.modalService.open(this.showModalBoxTemplate);
            var v = response;
          }
        }
      },
        (err: any) => {
          var message = err;
        });
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('10');
  }
  goBack() {
    this.eventService.emit<string>('10');
  }

  onOptionsSelected() {

    var startval = Number(this.selectedStartYear);
    var toval = Number(this.selectedEndYear);

    if (startval >= toval) {
      this.yearGreaterthan = true;
      //alert('yeart to is gerater than year start');
    }
    else {
      this.yearGreaterthan = false;
    }

  }

  onOptionsSelectedStart() {
    var startval = Number(this.selectedStartYear);
    var toval = Number(this.selectedEndYear);

    if (startval >= toval) {
      this.yearSmallerthan = true;
      //alert('yeart to is gerater than year start');
    }
    else {
      this.yearSmallerthan = false;
    }
  }
}
